module.exports = __webpack_public_path__ + "img/hireai.b2fcfec6.svg";